export const APP_VERSION = import.meta.env.PACKAGE_VERSION;
export const DISCORD_LINK = "https://discord.gg/4jzBvV8E5r";
export const GITHUB_LINK = "https://github.com/joshholly/VidBinge";
export const DONATION_LINK = "https://ko-fi.com/vidbinge";
export const FACEBOOK_LINK = "https://facebook.com/vidbinge";
export const INSTAGRAM_LINK = "https://instagram.com/vidbinge";
export const GA_ID = import.meta.env.VITE_GA_ID;
export const BACKEND_URL = import.meta.env.VITE_BACKEND_URL;
